import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trend-indicator',
  imports: [
    CommonModule
  ],
  templateUrl: './trend-indicator.component.html',
  standalone: true,
  styleUrls: ['./trend-indicator.component.css'],
})
export class TrendIndicatorComponent {
  @Input() value: number = 0.0;
  @Input() type: 'FR' | 'FC' | 'O2' | 'STP' = 'FC';

  public getIcon(): string {
    if (!this.value) return '';

    if (this.value > 0.0) {
      return 'pi pi-arrow-up-right'
    } else {
      return 'pi pi-arrow-down-right'
    }
  }

  public getColor(): string {
    if (!this.value) return '';

    const s1 = this.getThresholdWarning();
    const s2 = this.getThresholdAlert();

    if (this.value >= s2) {
      return 'border border-red-500 bg-red-100  text-red-500'
    } else if (this.value >= s1) {
      return 'border border-yellow-700 bg-yellow-100  text-yellow-700'
    } else if (this.value <= -s1) {
      return 'border border-yellow-700 bg-yellow-100  text-yellow-700'
    } else {
      return ''
    }
  }

  private getThresholdAlert(): number {
    switch (this.type) {
      case 'FR':
      case 'STP':
        return 0.2;

      case 'FC':
      case 'O2':
        return 0.1;

      default:
        return 0.0;
    }
  }

  private getThresholdWarning(): number {
    switch (this.type) {
      case 'FR':
      case 'STP':
        return 0.1;

      case 'FC':
      case 'O2':
        return 0.05;

      default:
        return 0.0;
    }
  }
}
